export const GET_SERVICE = 'serviceManager/GET_SERVICE';
export const GET_SERVICE_SUCCESS = 'serviceManager/GET_SERVICE_SUCCESS';
export const GET_SERVICE_FAIL = 'serviceManager/GET_SERVICE_FAIL';

export const FLAG_SERVICE = 'serviceManager/FLAG_SERVICE';
export const FLAG_SERVICE_SUCCESS = 'serviceManager/FLAG_SERVICE_SUCCESS';
export const FLAG_SERVICE_FAIL = 'serviceManager/FLAG_SERVICE_FAIL';



// WEBPACK FOOTER //
// ./src/redux/constants/serviceManager.js